import { useState } from "react";
import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import FrostedCard from "src/components/quote/FrostedCard";
import AsiakasEditDialog from "src/components/AsiakasEditDialog";
import { useT } from "src/i18n";

// company: { asiakasId, asiakasNimi, asiakasTypeId, ytunnus, laskutusOsoite, laskutusPostinumero, laskutusKaupunki }
// Only rendered for typeId=1 (company) rows — the /hallinta gate filters to asiakasTypeId===1.
export default function CompanyBasicsCard({ company, canEdit }) {
    const t = useT();
    const [open, setOpen] = useState(false);
    const [row, setRow] = useState(company);

    return (
        <FrostedCard sx={{ p: 3 }}>
            <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "flex-start" }}>
                <Box>
                    <Typography variant="h6" sx={{ fontWeight: 700 }}>{row.asiakasNimi}</Typography>
                    <Stack direction="row" spacing={1} sx={{ mt: 0.5, alignItems: "center" }}>
                        {row.ytunnus && <Typography variant="body2" sx={{ color: "text.secondary" }}>{t("provider.companyBasics.ytunnusPrefix", { value: row.ytunnus })}</Typography>}
                        <Chip size="small" label={Number(row.asiakasTypeId) === 1 ? t("provider.shared.companyType") : t("provider.shared.privateType")} />
                    </Stack>
                    {(row.laskutusOsoite || row.laskutusKaupunki) && (
                        <Typography variant="body2" sx={{ color: "text.secondary", mt: 1 }}>
                            {[row.laskutusOsoite, [row.laskutusPostinumero, row.laskutusKaupunki].filter(Boolean).join(" ")].filter(Boolean).join(", ")}
                        </Typography>
                    )}
                </Box>
                {canEdit && <Button startIcon={<EditIcon />} size="small" onClick={() => setOpen(true)}>{t("provider.shared.edit")}</Button>}
            </Stack>
            {open && (
                <AsiakasEditDialog
                    open
                    onClose={() => setOpen(false)}
                    asiakas={row}
                    onSaved={(result) => setRow((prev) => ({ ...prev, ...result }))}
                />
            )}
        </FrostedCard>
    );
}
